import axios from 'axios';
import {
  getIdbItem,
  getLocalStorageItem,
  setIdbItem,
  parseKeyValue,
  setLocalStorageItem,
  addUpdateKeyValue,
  StorageConstants
} from '../../../utils/clientStorage';
import { getConfig } from '../../../config/apiConfig';

const getSitemap = async (foreceRefreshSitemap) => {
  const rcoreSitemapHash = getLocalStorageItem(StorageConstants.Keys.sitemap);
  let sitemapRequest = { sitemapHash: null, dashboardHash: null };
  let cachedRcoreSiteMap = {};

  if (foreceRefreshSitemap !== true) {
    let hashValues = null;
    // Get sitemap hash
    cachedRcoreSiteMap = await getIdbItem('RCoreSitemap');
    if (rcoreSitemapHash && cachedRcoreSiteMap) {
      hashValues = parseKeyValue(rcoreSitemapHash);
    }
    sitemapRequest = {
      sitemapHash: hashValues ? hashValues.get(StorageConstants.SitemapHash) : null,
      dashboardHash: hashValues ? hashValues.get(StorageConstants.DashboardHash) : null,
      rcoreDashboardHash: hashValues ? hashValues.get(StorageConstants.RcoreDashboardHash) : null
    };
  }
  // Get auth header config
  const config = await getConfig();
  return axios
    .post('api/rcore/sitemap', sitemapRequest, config)
    .then(async (resp) => {
      let response = resp;
      // Refresh client storage with updated data if received from server
      if (
        response.data &&
        response.data.sitemap &&
        response.data.sitemap.nodes &&
        response.data.sitemap.nodes.length > 0
      ) {
        // Update sitemap hash to local storage
        const updatedHash = addUpdateKeyValue(
          rcoreSitemapHash,
          StorageConstants.SitemapHash,
          response.data.sitemap.hash
        );
        setLocalStorageItem(StorageConstants.Keys.sitemap, updatedHash);

        // Add profile menus to sitemap in order to store single object in cache
        response.data.sitemap.profileMenus = response.data.profileMenus;
        // Store sitemap in indexed db
        await setIdbItem('RCoreSitemap', response.data.sitemap);
      } else if (response.data && response.data.sitemap) {
        // Get the data from client storage
        response.data.sitemap = cachedRcoreSiteMap;
      } else {
        response = { data: { sitemap: { nodes: [] } } };
      }
      const respObj = await includeDashboardSitemap(response.data);

      return respObj;
    })
    .catch((err) => {
      throw err.response;
    });
};

const includeDashboardSitemap = async (response) => {
  // Get accessible dashboards of the user and add them to self menu of the sitemap response
  if (
    response.dashboardSitemap &&
    response.dashboardSitemap.nodes &&
    response.dashboardSitemap.nodes.length > 0
  ) {
    const dashboardParent = response.dashboardSitemap.nodes.filter(
      (t) => t.nodeKey === 'manage_dashboard_listmenu'
    )[0];
    if (dashboardParent && dashboardParent.childNodes && dashboardParent.childNodes.length > 0) {
      /* Select only dashboards with dashboardType = 0 representing dashboards,
       skip dashboardType = 1 representing workspaces */
      const dashboards = dashboardParent.childNodes.filter((t) => t.dashboardType === 0);
      dashboardParent.childNodes = dashboards;

      // Add Dashboard sitemap to the self menu
      const selfNode = response.sitemap.nodes.find((t) => t.nodeKey === 'self_header');
      if (selfNode) {
        // Remove dashboards node if it already exists in Self menu
        selfNode.childNodes = selfNode.childNodes.filter(
          (t) => t.nodeKey !== 'manage_dashboard_listmenu'
        );
        selfNode.childNodes.unshift(dashboardParent);
      }
    }
    // Update dashboard hash to local storage
    const rcoreSitemapHash = getLocalStorageItem(StorageConstants.Keys.sitemap);
    const updatedHash = addUpdateKeyValue(
      rcoreSitemapHash,
      StorageConstants.DashboardHash,
      response.dashboardSitemap.hash
    );
    setLocalStorageItem(StorageConstants.Keys.sitemap, updatedHash);

    // Store dashboard sitemap in indexed db
    await setIdbItem('RCoreDashboardSitemap', response.dashboardSitemap);
  } else if (response && response.dashboardSitemap) {
    // Get dashboard data from client storage indexed db
    response.dashboardSitemap = await getIdbItem('RCoreDashboardSitemap');
  } else {
    response.dashboardSitemap = { nodes: [] };
  }

  if (
    response.rcoreDashboardSitemap &&
    response.rcoreDashboardSitemap.nodes &&
    response.rcoreDashboardSitemap.nodes.length > 0
  ) {
    const dashboardParent = response.rcoreDashboardSitemap.nodes.filter(
      (t) => t.nodeKey === 'manage_rcore_dashboard_listmenu'
    )[0];
    if (dashboardParent && dashboardParent.childNodes && dashboardParent.childNodes.length > 0) {
      // Add Dashboard sitemap to the self menu
      const selfNode = response.sitemap.nodes.find((t) => t.nodeKey === 'self_header');
      if (selfNode) {
        // Remove dashboards node if it already exists in Self menu
        selfNode.childNodes = selfNode.childNodes.filter(
          (t) => t.nodeKey !== 'manage_rcore_dashboard_listmenu'
        );
        selfNode.childNodes.unshift(dashboardParent);
      }
    }
    // Update dashboard hash to local storage
    const rcoreSitemapHash = getLocalStorageItem(StorageConstants.Keys.sitemap);
    const updatedHash = addUpdateKeyValue(
      rcoreSitemapHash,
      StorageConstants.RcoreDashboardHash,
      response.rcoreDashboardSitemap.hash
    );
    setLocalStorageItem(StorageConstants.Keys.sitemap, updatedHash);

    // Store dashboard sitemap in indexed db
    await setIdbItem('LatestDashboardsSitemap', response.rcoreDashboardSitemap);
  } else if (response && response.rcoreDashboardSitemap) {
    // Get dashboard data from client storage indexed db
    response.rcoreDashboardSitemap = await getIdbItem('LatestDashboardsSitemap');
  } else {
    response.rcoreDashboardSitemap = { nodes: [] };
  }
  return response;
};

export default getSitemap;
